<ion-grid class="footer-container" fixed>
  <div class="browser-footer-main-section">
    <div class="footer-navs">
      <div class="footer-logo"></div>
      <div class="navs">
        <app-router-link [path]="['vendors', 'join']">
          <span>{{ "FOOTER.FOR_VENDORS" | translate }}</span>
        </app-router-link>
        <app-router-link [path]="['business']">
          <span>{{ "FOOTER.FOR_BUSINESS" | translate }}</span>
        </app-router-link>
        <app-router-link [path]="['press']">
          <span>{{ "FOOTER.PRESS" | translate }}</span>
        </app-router-link>
        <app-router-link [path]="['terms']">
          <span>{{ "FOOTER.TERMS_AND_CONDITIONS" | translate }}</span>
        </app-router-link>
        <app-router-link [path]="['policy']">
          <span>{{ "FOOTER.PRIVACY_POLICY" | translate }}</span>
        </app-router-link>
        <app-router-link [path]="['about']">
          <span>{{ "FOOTER.ABOUT_US" | translate }}</span>
        </app-router-link>
        <app-router-link [path]="['contact']">
          <span>{{ "FOOTER.CONTACT_US" | translate }}</span>
        </app-router-link>
      </div>
    </div>
    <div class="social-media">
      <p class="footer-section-title">{{ "FOOTER.FOLLOW_US" | translate }}</p>
      <div class="social-media-links">
        <a tappable href="https://www.facebook.com/bilbayt" target="_blank">
          <ion-icon src="/assets/custom-icons/facebook.svg"></ion-icon>
        </a>
        <a tappable href="https://twitter.com/bilbayt" target="_blank">
          <ion-icon src="/assets/custom-icons/twitter.svg"></ion-icon>
        </a>
        <a tappable href="https://instagram.com/bilbayt" target="_blank">
          <ion-icon src="/assets/custom-icons/instagram.svg"></ion-icon>
        </a>
      </div>
    </div>
    <div class="stores">
      <p class="footer-section-title">{{ "FOOTER.ORDER_FROM_YOUR_PHONE" | translate }}</p>
      <div class="stores-links">
        <a
          tappable
          target="_blank"
          class="app-store"
          href="https://itunes.apple.com/app/bilbayt/id1052726070?mt=8&utm_source=Bilbaytwebsite&utm_medium=websitereferral"
        >
        </a>
        <a
          tappable
          target="_blank"
          class="google-play"
          href="https://play.google.com/store/apps/details?id=com.bilbayt.bilbayt&utm_source=Bilbaytwebsite&utm_medium=websitereferral"
        >
        </a>
      </div>
    </div>
  </div>
  <div class="stats">
    <ng-container *ngIf="isProduction"> {{ "BILBAYT" | translate }} v{{ appVersion }} </ng-container>
    <ng-container *ngIf="!isProduction"> {{ environmentName }} v{{ appVersion }} </ng-container>
  </div>
</ion-grid>
